import React from "react";
import logo from "../assets/watcho-logo-small.png";
import { Outlet } from "react-router-dom";
import "./layout.css";

const LayoutQRC = () => {
  return (
    <>
      <div id="header" className="fixed">
        <div className="app-header">
          <div id="desktop-head-nav">
            <div className="navbar-brand">
              <a href="https://www.vzy.one">
                <img src={logo} className="logo" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div id="containerQRC11">
        <Outlet />
      </div>
    </>
  );
};

export default LayoutQRC;
